export const nounPath = (nounId: Number) => `/noun/${nounId}`;
